import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})

export class UserService {
  private baseURL: string;
  constructor(private http: HttpClient,
    private authService: AuthService
  ) {
    this.baseURL = environment.apiBaseUrl;
  }

  public options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
       var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
       return v.toString(16);
    });
 }

  setSessionData(marketId: string, vendorId: string) {
    if (!sessionStorage.getItem('tabId')) {
      sessionStorage.setItem('tabId', this.generateUUID());
    }
    const tabId = sessionStorage.getItem('tabId');
    const key1 = `marketId-${tabId}`;
    const key2 = `vendorId-${tabId}`;
    localStorage.setItem(key1, marketId);
    localStorage.setItem(key2, vendorId);
  }

  getMarketId(): string | null {
    const tabId = sessionStorage.getItem('tabId');
    const key1 = `marketId-${tabId}`;
    return localStorage.getItem(key1);
  }

  getVendorId(): string | null {
    const tabId = sessionStorage.getItem('tabId');
    const key2 = `vendorId-${tabId}`;
   return localStorage.getItem(key2);
  }

  clearSession() {
    if (!sessionStorage.getItem('tabId')) {
      sessionStorage.setItem('tabId', this.generateUUID());
    }
    const tabId = sessionStorage.getItem('tabId');
    const key1 = `marketId-${tabId}`;
    const key2 = `vendorId-${tabId}`;
    localStorage.removeItem(key1);
    localStorage.removeItem(key2);
  }

  getToken(userData): Observable<any> {
    const url = `${this.baseURL}/user`;
    return this.http.post<any>(url, userData, this.options)
      .pipe(
        map(res => {
          this.authService.isLoggedIn = false;
          if (res.Token) {
            this.authService.isLoggedIn = true;
            localStorage.setItem('token', res.Token);
            return res;
          }
          else if (res.Error == "vendorOnHold") {
            return res;
          }
        }),
        catchError(this.handleError)
      );
  }

  clearToken(): void {
    localStorage.removeItem('token');
    this.authService.isLoggedIn = false;
  }

  ForgotPassword(marketId, email): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/user/VendorWRLoginForgotPassword?marketId=${marketId}`
    return this.http.post<any>(url, { email }, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      // this.appinsights.logEvent(errMessage);
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
} 